import * as Yup from "yup";


export const ReportSchema = Yup.object({
  doctor: Yup.string().required("Select Doctor"),
  patient: Yup.string().required("Select Patient"),
  type: Yup.string().required("Select Test Type"),
  
  captureImg: Yup.string(),
  imgFile: Yup.string(),
  validationError: Yup.string().when(['captureImg', 'imgFile'], {
    is: (captureImg, imgFile) => !captureImg && !imgFile,
    then: Yup.string().required("Either capture image or select file is required"),
  }),
});